const _ = "_breadcrumb_1w7l0_1", r = "_breadcrumb__link_1w7l0_8", e = "_breadcrumb__icon_1w7l0_36", b = "_breadcrumb__text_1w7l0_45", c = "_breadcrumb__separator_1w7l0_60", a = {
  breadcrumb: _,
  breadcrumb__link: r,
  "breadcrumb__link--selected": "_breadcrumb__link--selected_1w7l0_22",
  breadcrumb__icon: e,
  breadcrumb__text: b,
  "breadcrumb__text--selected": "_breadcrumb__text--selected_1w7l0_51",
  breadcrumb__separator: c
};
export {
  _ as breadcrumb,
  e as breadcrumb__icon,
  r as breadcrumb__link,
  c as breadcrumb__separator,
  b as breadcrumb__text,
  a as default
};
//# sourceMappingURL=Breadcrumb.module.scss.js.map
